import { Observable } from 'rxjs';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { DialogConfirmType } from './dialog-confirm.model';
import { UtilitiesService } from 'app/services/utilities/utilities.service';

@Component({
  selector: 'act-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss']
})
export class DialogConfirmComponent implements OnInit, OnDestroy {
  public pageElementName = 'dialog-confirm-close';
  public titleText: string;
  public descriptionText: string;
  public cancelText: string;
  public confirmText: string;
  public isLoading = false;
  public confirmAction: () => Observable<boolean>
  public template: number;
  public imgPath: string = '/assets/images/search/Budgetlimit.png';
  public DialogConfirmType = DialogConfirmType;

  constructor(
    private utilitiesService: UtilitiesService,
    @Inject(MD_DIALOG_DATA) type: { confirmType: DialogConfirmType, data: any },
    public dialogRef: MdDialogRef<DialogConfirmComponent>) {
    switch (type.confirmType) {
      case DialogConfirmType.CONFIRM_CLOSE:
        this.titleText = 'dialog-confirm-close-title';
        this.descriptionText = 'dialog-confirm-close-desc';
        this.cancelText = 'dialog-confirm-close-cancel';
        this.confirmText = 'dialog-confirm-close-confirm';
        break;
      case DialogConfirmType.CONFIRM_DELETE_ADDRESS:
        this.titleText = 'dialog-confirm-delete-title';
        this.descriptionText = 'dialog-confirm-delete-address-desc';
        this.cancelText = 'dialog-confirm-delete-cancel';
        this.confirmText = 'dialog-confirm-delete-confirm';
        this.confirmAction = type.data.confirmAction
        break;
      case DialogConfirmType.CONFIRM_AVAILABLE_BUDGET:
        this.descriptionText = type.data.message;
        this.cancelText = 'dialog-confirm-delete-cancel';
        this.confirmText = 'btn-ok';
        this.template = DialogConfirmType.CONFIRM_AVAILABLE_BUDGET;
        break;
      case DialogConfirmType.CONFIRM_CONTINUE_BOOKER_BUDGET:
        this.descriptionText = type.data.message;
        this.cancelText = 'dialog-confirm-change-search';
        this.confirmText = 'dialog-confirm-change-continue-share-budget';
        this.template = DialogConfirmType.CONFIRM_CONTINUE_BOOKER_BUDGET;
        break;
      case DialogConfirmType.CONFIRM_CANCEL_SHARE_BUDGET:
        this.descriptionText = type.data.message;
        this.cancelText = 'dialog-confirm-change-search';
        this.confirmText = 'dialog-confirm-cancel-share-budget';
        this.template = DialogConfirmType.CONFIRM_CANCEL_SHARE_BUDGET;
        break;
      case DialogConfirmType.CONFIRM_CANCEL_SHARE_BUDGET_FROM_USER:
        this.descriptionText = type.data.message;
        this.cancelText = 'dialog-confirm-delete-cancel';
        this.confirmText = 'dialog-confirm-cancel-share-budget';
        this.template = DialogConfirmType.CONFIRM_CANCEL_SHARE_BUDGET;
        break;
      case DialogConfirmType.CONFIRM_CONTINUE_BOOKING:
        this.descriptionText = type.data.message;
        this.cancelText = 'dialog-confirm-delete-cancel';
        this.confirmText = type.data.confirmText;
        this.template = DialogConfirmType.CONFIRM_CANCEL_SHARE_BUDGET;
        this.imgPath = type.data.imgPath;
        break;
      case DialogConfirmType.CONFIRM_CONTINUE_WITHOUT_PROMOTION_CODE:
        this.titleText = 'cart-dialog-confirm-continue-without-promotion-code-title';
        this.descriptionText = 'cart-dialog-confirm-continue-without-promotion-code-desc';
        this.cancelText = utilitiesService.isMobile() ? 'cart-dialog-confirm-continue-without-promotion-code-cancel-short' : 'cart-dialog-confirm-continue-without-promotion-code-cancel';
        this.confirmText = utilitiesService.isMobile() ? 'cart-button-continue' : 'cart-dialog-confirm-continue-without-promotion-code-confirm';
        this.template = DialogConfirmType.CONFIRM_CONTINUE_WITHOUT_PROMOTION_CODE;
        this.imgPath = '/assets/images/checkout/promotion_code/no_promo_code.png';
        break;
    }
  }

  ngOnInit() {
  }

  handleClose() {
    this.dialogRef.close();
  }

  handleConfirm() {
    if (this.confirmAction) {
      this.isLoading = true;
      this.confirmAction && this.confirmAction().subscribe((res) => {
        this.isLoading = true;
        res && this.dialogRef.close({ status: 'CONFIRM' })
      });
    } else {
      this.dialogRef.close({ status: 'CONFIRM' });
    }
  }

  ngOnDestroy(): void {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-confirm/dialog-confirm.component.ts